import clsx from "clsx";
import type { ReactNode } from "react";
import { ToneMarker } from "../status/StatusBadge";
import type { Tone } from "../status/statusMap";

export interface VerticalProgressStep { tone: Tone; title: ReactNode; detail?: ReactNode }

/** Vertical list of steps with a tone marker each (request progress: sent → approved → provisioned). */
export function VerticalProgress({ steps, className }: { steps: VerticalProgressStep[]; className?: string }) {
  return (
    <ol className={clsx("flex flex-col", className)}>
      {steps.map((s, i) => (
        <li key={i} className="relative flex gap-3 pb-5 last:pb-0">
          {i < steps.length - 1 && <span aria-hidden="true" className="absolute left-[11px] top-6 bottom-0 w-px bg-line" />}
          <span className={clsx("mt-0.5 inline-flex h-6 w-6 flex-none items-center justify-center rounded-full", `iga-tone-${s.tone}`)}><ToneMarker tone={s.tone} /></span>
          <div className="min-w-0 flex-1">
            <div className="font-semibold">{s.title}</div>
            {s.detail && <div className="text-small text-fg-3">{s.detail}</div>}
          </div>
        </li>
      ))}
    </ol>
  );
}
